function AdminIndex() {
  return <h1>AdminIndex</h1>;
}

export default AdminIndex;
